import { useAuthStore } from '@/store/authStore';

export function useAuth() {
  const {
    user,
    isLoading,
    isAuthenticated,
    beginLogin,
    completeLoginWithTotp,
    logout,
  } = useAuthStore();

  return {
    user,
    isLoading,
    isAuthenticated,
    beginLogin,
    completeLoginWithTotp,
    logout,
    isSuperAdmin: user?.is_super_admin === true,
  };
}
